import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/**
 * /vip/:code — invisible landing page.
 *
 * Stores the code in sessionStorage under `mp-promo-code` so CapsuleForm
 * can auto-apply it on the homepage, then transparently redirects to `/`
 * (no query params) for a clean, share-friendly URL experience.
 */
export default function VipRedeemPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (code) {
        sessionStorage.setItem("mp-promo-code", code.toUpperCase());
      }
    } catch { /* private mode / storage full — ignore */ }
    navigate("/", { replace: true });
  }, [code, navigate]);

  return null;
}
